import React, { useState } from 'react';
import { AppCreatableSelect } from './AppSelect';

const MultiSelect = ({ options, placeholder, onChange }) => {
    const [selectedOptions, setSelectedOptions] = useState([]);


    const handleChange = (newValue) => {
        setSelectedOptions(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div>
            <AppCreatableSelect
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                placeholder={placeholder || 'Select or create options...'}
                className="basic-multi-select"
            />
        </div>
    );
};

export default MultiSelect;
